import { convertDateToyyyymmdd } from "./date"

export const initialInputData = {
  PPDATE: convertDateToyyyymmdd(new Date()),
  PPTIME: null,
  PKCDXX: null,
  BSSWGH: null,
  HOGIXX: 2,
  SPEEDX: null,
  SBSSWG: null,
  WATERX: null,
  THICKX: null,
  MILDOX: null,
  MDABGA: null,
  CDABGA: null,
  CDINDX: null,
  MDCDXX: null,
  PAGANG: null,
  PAINDX: null,
  COBBTE: null,
  COBBDE: null,
  COBBSI: null,
  COLORL: null,
  COLORA: null,
  COLORB: null,
}